"use strict";

exports.__esModule = true;
var _Footer = _interopRequireDefault(require("./Footer"));
exports.default = _Footer.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}